import { render, staticRenderFns } from "./Attack.vue?vue&type=template&id=66a07442"
import script from "./Attack.vue?vue&type=script&lang=js"
export * from "./Attack.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports